import { isRouteErrorResponse } from 'react-router-dom'

import { logger } from '@/lib/logger'

export type RouteErrorContent = {
  title: string
  description: string
}

export function resolveRouteErrorContent(error: unknown): RouteErrorContent {
  let title = 'Something went wrong'
  let description = 'An unexpected error occurred. Please try again.'

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = 'Page not found'
      description = "The page you're looking for doesn't exist or has been moved."
    } else if (error.status === 403) {
      title = 'Access denied'
      description = "You don't have permission to view this page."
    } else {
      title = `Error ${error.status}`
      description = error.statusText || description
    }
    logger.error('Route error response', {
      status: error.status,
      statusText: error.statusText,
      data: error.data,
    })
    return { title, description }
  }

  logger.error('Unhandled route error', {
    err: error instanceof Error ? error : new Error(String(error)),
  })

  if (import.meta.env.DEV) {
    if (error instanceof Error) {
      description = error.message
    } else if (typeof error === 'string') {
      description = error
    }
  }

  return { title, description }
}
